import * as Highcharts from 'highcharts';
import * as _ from 'underscore';

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-sparkline',
	styleUrls: ['./sparkline.component.css'],
	templateUrl: './sparkline.component.html'
})
export class SparklineComponent implements WidgetCore, OnInit, AfterViewInit, OnDestroy {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;

	public colors: string;
	public sectiontitle: string;
	public key: string;
	public groupby: string;

	public chartData: number[] = [];
	public width = 0;
	public height = 0;
	public noData = false;
	public sparklineColors: string[] = [];
	public chartObj: any;
	public reloadSubscription;
	public widgetDataSubscription;

	constructor(
		private analyticsService: AnalyticsService,
		private colorUtilityService: ColorUtilityService,
		private analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.sparklineColors = this.colors.split(',');
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
		this.chartData = [];
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			if (response.success) {
				this.noData = !(response.data.length > 0);
				if (!this.noData) {
					this.processResponseData(response.data);
				}
			} else {
				this.noData = true;
			}
		});
	}

	processResponseData(responseData: any): void {
		this.chartData = _.map(_.pluck(responseData, this.groupby), (val) => {
			return parseInt(val, 10);
		});
		this.calculateWidthBasedOfData();
		/**
		 * ngIf to take effect before drawing chart
		 */
		setTimeout(() => {
			this.drawSparkLine();
		}, 100);
	}

	calculateWidthBasedOfData(): void {
		if (this.chartData.length !== 0 && this.chartData.length < 10) {
			this.width = 60;
		} else if (this.chartData.length >= 10 && this.chartData.length < 15) {
			this.width = 80;
		} else if (this.chartData.length >= 15 && this.chartData.length < 20) {
			this.width = 130;
		} else if (this.chartData.length >= 20 && this.chartData.length < 30) {
			this.width = 150;
		} else if (this.chartData.length >= 30) {
			this.width = 150;
		}
	}

	drawSparkLine(): void {
		this.chartObj = new Highcharts.Chart({
			chart: {
				backgroundColor: 'transparent',
				height: 30,
				margin: [0, 0, 0, 0],
				renderTo: this.chartElement.nativeElement,
				width: this.width
			},
			credits: {
				enabled: false
			},
			legend: {
				enabled: false
			},
			plotOptions: {
				area: {
					fillOpacity: 1
				},
				series: {
					animation: true,
					borderWidth: 0,
					color: this.colorUtilityService.getHEXByColorType(
						this.analyticsDataModel.partner.colorPalette,
						this.sparklineColors[0],
						1
					),
					enableMouseTracking: false,
					lineWidth: 0,
					marker: {
						radius: 0,
						states: {
							hover: {
								radius: 0
							}
						}
					},
					shadow: false,
					states: {
						hover: {
							lineWidth: 10
						}
					}
				}
			},
			series: [
				{
					data: this.chartData,
					type: 'column'
				}
			],
			title: {
				text: ''
			},
			tooltip: {
				backgroundColor: null,
				borderWidth: 0,
				hideDelay: 0,
				padding: 0,
				shadow: false,
				shared: true,
				useHTML: true
			},
			xAxis: {
				labels: {
					enabled: false
				}
			},
			yAxis: {
				endOnTick: false,
				gridLineWidth: 0,
				labels: {
					enabled: true
				},
				maxPadding: 0,
				minPadding: 0
			}
		});
	}
}
